<template>
  <div class="p-6 justify-center items-center text-black">
    <img alt="lshtm-logo" src="@/assets/logo-black.svg" class="w-40 m-auto" />
    <div class="sm:w-full md:w-1/2 lg:w-1/3 m-auto">
      <form class="mt-8 bg-gray-100 overflow-hidden border" action="#" @submit.prevent="register">
        <div class="px-10 py-12">
          <h1 class="text-black font-bold text-3xl mb-4">Applicant Portal - Register</h1>
          <p class="mb-6">
            Please read our 
            <a class="text-green-500 underline hover:text-orange-600"
              href="https://www.lshtm.ac.uk/study/applications"
              target="_blank">How to Apply</a>
              webpages before commencing your application.
          </p>
          <div class="mx-auto mt-6 mb-6 w-24 border-b-2" />

          <div v-if="serverErrors" class="server-error">
            <div v-for="(value, key) in serverErrors" :key="key">
              {{ value[0] }}
            </div>
          </div>

          <label class="block text-black-600 text-sm mb-2 mt-4 text-left" for="first_name">Name:</label>
          <input
            id="first_name"
            v-model="first_name"
            type="text"
            name="first_name"
            class="appearance-none border rounded border-gray-300 w-full py-2 px-3 text-black-600 leading-tight focus:outline-none focus:shadow-outline"
          />

          <label class="block text-black-600 text-sm mb-2 mt-4 text-left" for="first_name">Email:</label>
          <input
            id="email"
            v-model="email"
            type="email"
            name="email"
            class="appearance-none border rounded border-gray-300 w-full py-2 px-3 text-black-600 leading-tight focus:outline-none focus:shadow-outline"
          />

          <label class="block text-black-600 text-sm mb-2 mt-4 text-left" for="first_name">Password:</label>
          <input
            id="password"
            v-model="password"
            type="password"
            name="password"
            class="appearance-none border rounded border-gray-300 w-full py-2 px-3 text-black-600 leading-tight focus:outline-none focus:shadow-outline"
          />

          <div class="py-4 bg-gray-100 border-t border-gray-100 flex justify-between">
            <router-link :to="{ name: 'Login' }">
              <div class="hover:bg-white border text-black-500 py-2 px-4 w-full rounded">Login</div>
            </router-link>
            <button
              class="bg-green-600 hover:bg-green-700 text-white py-2 px-4 w-full lg:w-1/2 rounded btn-submit"
              :disabled="loading"
              type="submit"
            >
              <div v-if="loading" class="lds-ring-container">
                <div class="lds-ring">
                  <div />
                  <div />
                  <div />
                  <div />
                </div>
              </div>
              Create Account
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      first_name: '',
      email: '',
      password: '',
      loading: false,
      serverErrors: '',
      successMessage: '',
    };
  },
  methods: {
    register() {
      this.loading = true;
      this.$store
        .dispatch('register', {
          first_name: this.first_name,
          email: this.email,
          password: this.password,
        })
        .then(() => {
          this.loading = false;
          this.successMessage = 'Account created successfully. Please login';
          this.$router.push({ name: 'emailVerificationNeeded' });
        })
        .catch((error) => {
          this.loading = false;
          this.serverErrors = Object.values(error.response.data.errors);
        });
    },
  },
};
</script>